import { render, staticRenderFns } from "./ClienteOperacao.vue?vue&type=template&id=24b9d15d"
import script from "./ClienteOperacao.vue?vue&type=script&lang=js"
export * from "./ClienteOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports